import React, { useState, useEffect, useCallback } from "react";
import { Container, Row } from "react-bootstrap";
import Header from "../Header";
import Footer from "../Footer";
import { MdArrowBackIos } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { GoChevronRight } from "react-icons/go";
import * as ascentwebApi from "../../api/ascentwebApi"
import * as employerApi from "../../api/employerApi"
import { useSignalAbort } from "../../api/useSignalAbort";
import { handleApiErrors } from '../../api/handleApiErrors';
import { ToastContainer,toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Divider = () => (
  <div style={{ borderBottom: "2px solid #dee2e6", margin: "20px 0" }}></div>
);

const defaultValue = {
  CompanyName: "",
  EmailId: "",
  JobTitle: "",
  RequiredNationality: "",
  ContactNo:"",
  ContactName: "",
  Website:"",
  Country:"",
  State: "",
  JobDescription: "",
  OtherQueries:"",
}

function EmployerForm() {
  const navigate = useNavigate();
  const abortConstants = useSignalAbort()
  const [validated, setValidated] = useState(false);
  const [Country,setCountry] = useState()
  const [Countryselect,setCountryselect] = useState("")
  const [Nationalityselect,setNationalityselect] = useState("")
  const [State,setState] = useState()
  const [Stateselect,setStateselect] = useState("")
  const [EmployerForm,setEmployerForm] = useState(defaultValue)
  const [isLoading, setIsLoading] = useState({})
  const [issubmit,setIsSubmit] = useState(false)

  ///getCountry
  const getCountry = async (abortToken) => {
    try {
      const result = await ascentwebApi.getCountry(Countryselect, abortToken);
      console.log(result?.data?.Country);
      setCountry(result?.data?.Country);
      setCountryselect(result?.data?.Country[0].countryId, abortToken)
      setNationalityselect(result?.data?.Country[0].countryId, abortToken)
    } catch (error) {
      handleApiErrors(error, 'Country', 'country_response', 'country_timeout', 'country_request', setIsLoading)
    }
  };
  //getState
  const getState = async (abortToken) => {
    try {
      const result = await ascentwebApi.getState(Stateselect, abortToken);
      console.log(result?.data?.State);
      setState(result?.data?.State);
      setStateselect(result?.data?.State[0].StateId)
    } catch (error) {
      handleApiErrors(error, 'State', 'state_response', 'state_timeout', 'state_request', setIsLoading)
    }
  };

  //Profile
  const employerForm = async (data, abortToken) => {
    try {
      const result = await employerApi.EmployerForm(data, abortToken);
      console.log(result);
      setIsSubmit(false);
      setEmployerForm(defaultValue)
      setValidated(false)
      setNationalityselect("")
      setCountryselect("")
      setStateselect("")
      // alert(result.data.message)
      toast.success( result.data.message,{
        autoClose: 3000, // Close the toast after 5 seconds
    });
    } catch (error) {
      setIsSubmit(false);
      console.error(error);
      handleApiErrors(error, 'EmployerForm', 'employerForm_response', 'employerForm_timeout', 'employerForm_request', setIsLoading)
    }
  };

  const getAllData = useCallback((abortToken) => {
    getCountry(abortToken);
    getState(abortToken);
  }, []);

  useEffect(() => {
    const abortController = new AbortController();
    getAllData(abortController.signal);

    return () => {
      // Cleanup logic if needed
      abortController.abort();
    };
  }, [getAllData]);

  const handleCountryselect = (e) => {
    setCountryselect(e.target.value);
    console.log(Countryselect);
  }
  const handleNationalityselect = (e) => {
    setNationalityselect(e.target.value);
    console.log(Nationalityselect);
  }
  const handleStateselect = (e) => {
    setStateselect(e.target.value);
    console.log(Stateselect);
  }


  const handleSubmit = (event) => {
    event.preventDefault();
    setIsSubmit(true)
    const form = event.currentTarget;
    let newData = {
      CompanyName:EmployerForm.CompanyName,
      EmailId:EmployerForm.EmailId,
      JobTitle:EmployerForm.JobTitle,
      RequiredNationality: Number(Nationalityselect),
      ContactNo:EmployerForm.ContactNo,
      ContactName:EmployerForm.ContactName,
      Website:EmployerForm.Website,
      CountryId: Number(Countryselect),
      StateId: Number(Stateselect),
      JobDescription:EmployerForm.JobDescription,
      OtherQueries:EmployerForm.OtherQueries
    };
    if (form.checkValidity() === false) {
      event.stopPropagation();
      setIsSubmit(false);
    }
    else {
      employerForm(newData, abortConstants.controllerConfig)

    }
    console.log(newData);
    setValidated(true);
  };

  const handleChange = (e) => {
    setEmployerForm({ ...EmployerForm, [e.target.name]: e.target.value })
  }

  const renderLoading = (item) => {
    if (isLoading[`${item}_response`] || isLoading[`${item}_request`] || isLoading[`${item}_timeout`] ) {
      return true
    }
    else {
      return false
    }
  }
  
  const validatePhone = (phone) => {
    const phoneRegex = /^[0-14]{15}$/; // Customize the regex as needed
    return phoneRegex.test(phone);
  };

  const validateEmail = (email) => {
    const emailRegex = /^[a-zA-Z0-9]+@[a-zA-Z0-9]+\.[A-Za-z]+$/
    return emailRegex.test(email);
  };

//Style
  const captionTextStyle = {
    fontSize: "2.1rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
    textAlign: "center",
  };

  const captionTextStyle2 = {
    fontSize: "2.1rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "black",
    textAlign: "center",
  };
  const captionformStylehead = {
    fontSize: "1.5rem",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    color: "#2855A1",
  };

  const iconStyle = {
    border: "none",
    color: "black",
    fontSize: "20px", // Set the font size to adjust the height and width
    marginLeft: "20px",
    marginRight: "5px", // Optional: Add some margin if needed
    cursor: "pointer", // Optional: Add cursor pointer for interaction
  };

  const captionTextStyle3 = {
    fontSize: "1.2rem",
    fontWeight: 600,
    textAlign: "center",
    lineHeight: "2.5", // Adjusted for better readability
    marginBottom: "2rem",
    padding: "20px",
  };

  const captionStyle = {
    textAlign: "left",
    boxShadow: "0px 8px 16px rgba(0, 0, 0, 0.1)",
    borderRadius: "10px",
    backgroundColor: "white",
    padding: "2px",
    width: "100%",
  };
  const formstyle = {
    width: "1200px",
    marginBottom: "50px",
    padding:'20px'
  };
  const colstyle = {
    marginTop: "20px",
  };
  const Buttoncolstyle = {
    marginTop: "30px",
    marginBottom: "30px",
  };

  const formstyleCaption = {
    marginBottom: "10px",
    fontSize: "1rem",
    fontWeight: 600,
  };
  const buttonStyle = {
    padding: "5px",
    fontSize: "15px",
    fontWeight: 600,
    border: "none",
    backgroundColor: "#FFE114",
    color: "black",
  };

  return (
    <div>
      <Container fluid style={{ margin: 0, padding: 0, overflowY: "hidden" }}>
        <div>
          <Header title="home" />
        </div>

        <div>
          <Container style={{ padding: "2px", marginTop: "50px" }}>
            <Row className="d-flex justify-content-between align-items-center">
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <span
                  style={iconStyle}
                  onClick={() => {
                    window.location.href = '/';
                  }}
                  // onClick={() => {
                  //   navigate("/");
                  // }}
                >
                  {" "}
                  <MdArrowBackIos />{" "}
                </span>
              </Col>
              <Col xs={12} sm={4} md={4} lg={4} xl={4}>
                <h3 style={captionTextStyle}>
                  {" "}
                  Employer
                  <span style={captionTextStyle2}> Form </span>
                </h3>
              </Col>
              <Col xs={12} sm={4} md={4} lg={6} xl={4}></Col>
            </Row>
            <Row>
              <Col>
                <p className="lead" style={captionTextStyle3}>
                  Streamline your hiring process with our Employer Form. Provide
                  your company details and job requirements, and let us connect
                  you with top talent suited to your needs.
                </p>
              </Col>
            </Row>
          </Container>
        </div>

        <div className="d-flex justify-content-center">
          <Form
            style={formstyle}
            noValidate
            validated={validated}
            onSubmit={handleSubmit}
          >
            <Col xs={12} sm={12} md={12} lg={12}>
              <div className="card h-100" style={captionStyle}>
                <div className="card-body">
                  <Col style={colstyle}>
                    <h3 style={captionformStylehead}>
                      {" "}
                      Complete the form below{" "}
                    </h3>
                    <Divider />
                  </Col>
                  <Row>
                    <Col xs={12} sm={12} md={12} lg={12} style={colstyle}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formstyleCaption}>
                          Company Name <span style={{ color: "red" }}>*</span>
                        </Form.Label>
                        <Form.Control
                          size="lg"
                          required
                          type="text"
                          maxLength="120"
                          name="CompanyName"
                          value={EmployerForm?.CompanyName}
                          onChange={handleChange}
                        />
                        <Form.Control.Feedback type="invalid">
                          Please provide Company Name.
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Required Job Title{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        type="text"
                        maxLength="120"
                        name="JobTitle"
                        value={EmployerForm?.JobTitle}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Required Job Title.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Company Email <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                           required
                           name="EmailId"
                           type="email"
                           maxLength="100"
                           value={EmployerForm?.EmailId}
                           onChange={handleChange}
                          //  isInvalid={EmployerForm?.EmailId!=="" ? !validateEmail(EmployerForm?.EmailId) :''}
                      />
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Company Email.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Required Nationality{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        size="lg"
                        required
                        name="Country"
                        value={Nationalityselect}
                        onChange={handleNationalityselect}
                      >
                        {Country ? (
                          <>
                            {Country.length !== 0 ? (
                              <>
                                {Country.map((item) => (
                                  <option
                                    key={item.countryName}
                                    name={item.countryName}
                                    value={item.countryId}
                                  >
                                    {item.countryName}
                                  </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("country") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Required Nationality.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Company Contact No{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                       size="lg"
                       required
                       name="ContactNo"
                       type="text"
                        pattern="[0-9]*"
                        inputMode="numeric"
                        aria-describedby="inputGroupPrepend"
                        maxLength="15"
                       value={EmployerForm?.ContactNo}
                       onChange={handleChange}
                      //  isInvalid={EmployerForm?.ContactNo!=="" ? !validatePhone(EmployerForm?.ContactNo) :''}
                      />
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide a valid Mobile No.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Contact Person’s Name{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        type="text"
                        maxLength="100"
                        name="ContactName"
                        value={EmployerForm?.ContactName}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Contact Person’s Name.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Website <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Control
                        size="lg"
                        required
                        type="text"
                        name="Website"
                        value={EmployerForm?.Website}
                        onChange={handleChange}
                      />
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Website.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Country <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        size="lg"
                        required
                        name="Country"
                        value={Countryselect}
                        onChange={handleCountryselect}
                      >
                        {Country ? (
                          <>
                            {Country.length !== 0 ? (
                              <>
                                {Country.map((item) => (
                                  <option
                                    key={item.countryName}
                                    name={item.countryName}
                                    value={item.countryId}
                                  >
                                    {item.countryName}
                                  </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("country") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide a Country.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Label style={formstyleCaption}>
                        Emirate/ Province{" "}
                        <span style={{ color: "red" }}>*</span>
                      </Form.Label>
                      <Form.Select
                        size="lg"
                        required
                        name="State"
                        value={Stateselect}
                        onChange={handleStateselect}
                      >
                        {State ? (
                          <>
                            {State.length !== 0 ? (
                              <>
                                {State.map((item) => (
                                  <option
                                  key={item.StateName}
                                  name={item.StateName}
                                  value={item.StateId}
                                >
                                  {item.StateName}
                                </option>
                                ))}
                              </>
                            ) : (
                              <h4 style={{ textAlign: "center" }}>No data</h4>
                            )}
                          </>
                        ) : (
                          <>
                            {renderLoading("state") && (
                              <h5 style={{ textAlign: "center" }}>No data</h5>
                            )}
                          </>
                        )}
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        {" "}
                        Please provide Emirate/ Province.
                      </Form.Control.Feedback>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formstyleCaption}>
                          Job Description
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          required
                          type="text"
                          maxLength="250"
                          name="JobDescription"
                          value={EmployerForm?.JobDescription}
                          onChange={handleChange}
                          placeholder="Type your job description here..."
                        />
                        <Form.Control.Feedback type="invalid">
                          {" "}
                          Please provide Job Description
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={12} lg={6} style={colstyle}>
                      <Form.Group className="mb-3">
                        <Form.Label style={formstyleCaption}>
                          Other Queries
                        </Form.Label>
                        <Form.Control
                          as="textarea"
                          rows={5}
                          required
                          type="text"
                          maxLength="250"
                          name="OtherQueries"
                          value={EmployerForm?.OtherQueries}
                          onChange={handleChange}
                          placeholder="Type your Queries here..."
                        />
                        <Form.Control.Feedback type="invalid">
                          {" "}
                          Please provide Other Queries
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                  </Row>
                  <Col
                        style={{
                          ...Buttoncolstyle,
                          display: "flex",
                          justifyContent: "end",
                        }}
                      >
                        {!issubmit &&<Button type="submit" size="lg" style={buttonStyle}>
                          &nbsp;&nbsp; Submit &nbsp;&nbsp;{" "}
                          <span style={{ fontSize: "20px" }}>
                            {" "}
                            <GoChevronRight />{" "}
                          </span>{" "}
                          &nbsp;&nbsp;
                        </Button>}
                        {issubmit && 
                          <Button className='btn btn-update' style={buttonStyle} >
                            <span className="btn-text">&nbsp;&nbsp;Submiting...&nbsp;&nbsp;</span><div className="spinner"></div>
                          </Button>}
                          {/* <ToastContainer /> */}
                      </Col>
                </div>
              </div>
            </Col>
          </Form>
        </div>

        <div>
          <Footer />
        </div>
      </Container>
    </div>
  );
}

export default EmployerForm;
